export * from './lib/stock-transfer-detail-view';
